import { render, staticRenderFns } from "./companyMsg.vue?vue&type=template&id=2a89e669"
import script from "./companyMsg.vue?vue&type=script&lang=js"
export * from "./companyMsg.vue?vue&type=script&lang=js"
import style0 from "./companyMsg.vue?vue&type=style&index=0&id=2a89e669&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports